<template>
  <v-container>
    <v-row>
      <v-col cols='12'>
        <v-data-table :headers='headers' :items='itens' class='elevation-1' :search="search" :items-per-page="itemsPerPage" @update:items-per-page=" v => itemsPerPage = v">
          <template v-slot:top>
            <v-toolbar flat color='white'>
              <v-toolbar-title v-text="$t('keywords.listing')" />
              <v-divider class='mx-4' inset vertical></v-divider>
              <v-btn v-has-permission="['desenvolvedor']" color='primary' dark class='mb-2' @click="editItem(null)">{{ $t('button.new') }}</v-btn>
              <v-spacer></v-spacer>
              <CollectionSelect class="mr-3 mt-5" v-model='collection'/>
              <v-btn color='primary' dark class='mb-2' @click="searchAll(null)">{{ $t('button.search') }}</v-btn>
            </v-toolbar>
            <v-toolbar flat color='white' v-if="$versionable.versions.fromTo > '1.0.0'">
              <ImportExportFromTo @import="searchAll()" :collection="collection" />
            </v-toolbar>
            <v-toolbar flat color='white'>
              <v-row>
                <SearchField v-model="fromSearch" :label="$t('fromto.search.from')" />
                <SearchField v-model="toSearch" :label="$t('fromto.search.to')" />
              </v-row>
            </v-toolbar>
          </template>
          <template v-slot:item.lastModified='{ item }'>
            <LastModify :date="item.lastModified" :by="item.lastModifiedBy"/>
          </template>
          <template v-slot:item.actions='{ item }'>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="orange" small class='mr-2' @click='editItem(item)'>mdi-pencil</v-icon>
              </template>
              <span v-text="$t('button.edit')" />
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-has-permission="['desenvolvedor']" v-on="on" color="red" small class='mr-2' @click='deleteItem(item)'>mdi-delete</v-icon>
              </template>
              <span v-text="$t('button.delete')" />
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="secondary" small class='mr-2' @click='exportItem(item)'>mdi-export</v-icon>
              </template>
              <span>Exportar</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            {{ $t('warnings.no_data_found') }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Servico from '@/services/FromToService'
import CollectionSelect from '../core/CollectionsSelect'
import { ImportExportService } from '@/services/module'
import IncludesIgnoreCase from '../../utils/IncludesIgnoreCase'
import SearchField from '../core/SearchField.vue'
import LastModify from '../core/LastModify.vue'
import ImportExportFromTo from './ImportExportFromTo.vue'

export default {
  name: 'fromToGrid',

  components: {
    CollectionSelect,
    SearchField,
    LastModify,
    ImportExportFromTo
  },

  data: () => ({
    search: '',
    collectionSearch: '',
    fromSearch: '',
    toSearch: '',
    collections: [],
    collection: '',
    itens: []
  }),

  computed: {
    version () { return this.$versionable.versions.fromTo },
    itemsPerPage: {
      get () {
        return this.$cookies.isKey('fromto_per_page') ? parseInt(this.$cookies.get('fromto_per_page')) : 10
      },
      set (value) {
        this.$cookies.set('fromto_per_page', value)
      }
    },
    headers () {
      return [
        {
          text: this.$t('fromto.list'),
          value: 'collection',
          sortable: true,
          align: 'start'
        },
        {
          text: this.$t('keywords.last_modify'),
          value: 'lastModified',
          sortable: true,
          show: this.version > '1.0.0'
        },
        {
          text: this.$t('fromto.from'),
          value: 'from',
          sortable: true,
          align: 'start',
          filter: fromValue => IncludesIgnoreCase(fromValue, this.fromSearch)
        },
        {
          text: this.$t('fromto.to'),
          value: 'to',
          sortable: true,
          align: 'start',
          filter: toValue => IncludesIgnoreCase(toValue, this.toSearch)
        },
        {
          text: this.$t('keywords.actions'),
          value: 'actions',
          sortable: false
        }
      ].filter(h => h.show ?? true)
    }
  },
  mounted () {
    this.searchAll()
  },

  methods: {

    exportItem (item) {
      if (!confirm('Tens certeza que deseja exportar este item?')) return
      const { collection, from } = item

      ImportExportService.export('fromto', `${collection}/${from}`)
    },

    searchAll () {
      Servico.findAll(this.collection)
        .then((list) => { if (list && list.data) this.itens = list.data })
        .catch(error => this.$message.error(`${this.$t('warnings.error.occurred')} : ${error}`))
    },

    editItem (item) {
      this.$emit('editItem', false, item)
    },

    deleteItem (item) {
      if (confirm(this.$t('warnings.confirm.delete'))) {
        Servico.delete(item)
          .then(() => {
            this.searchAll()
            this.itens = []
          })
          .catch((error) => this.$message.error(`${this.$t('warnings.error.delete')} : ${error}`))
      }
    }
  },

  watch: {
    collection () { this.searchAll() }
  }

}
</script>
